import actionConstants from 'Actions/constants';

export const initialState = {
    isFetching: false,
    isError: false,
    isSuccess: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `CUSTOM_RECEIVE_${actionConstants.CAR_RESERVE_STATUS}`:
            return {
                ...state,
                isFetching: false,
                isError: false,
                isSuccess: true
            };

        case `REQUEST_${actionConstants.CAR_RESERVE_STATUS}`:
            return {
                ...state,
                isFetching: true,
                isError: false,
                isSuccess: false
            };

        case `ERROR_${actionConstants.CAR_RESERVE_STATUS}`:
            return {
                ...state,
                isFetching: false,
                isError: true,
                isSuccess: false
            };

        case actionConstants.RESET_CAR_RESERVE_STATUS:
            return {
                ...state,
                ...initialState
            };

        default:
            return state || null;
    }
};
